angular.module('invoice')
    .component('invoiceBgtGroupList', {
        bindings: {
            page: '<',
            filters: '<'
        },
        templateUrl: 'app/invoice/bgt-group/list.html',
        controller: function ($scope, $httpParamSerializer, $state, $stateParams, Principal, InvoiceBgtGroupService, InvoiceService, InvoiceBgtGroup, InvoiceBgtGroupConst) {
            this.reset = () => this.filters = {}
            this.packTypes = [ 'DIRECT', 'INDIRECT', 'FINANCIAL', 'CF_FUND' ]
            this.InvoiceService = InvoiceService
            this.InvoiceBgtGroupService = InvoiceBgtGroupService

            this.$onInit = () => {
                this.canEdit = Principal.hasAnyAuthority(['ROLE_INVOICE_BGT_WRITE'])
                if(this.filters.parent != null){
                    InvoiceBgtGroup.get({id: this.filters.parent}).$promise.then(entity => {
                        this.parent = entity;
                    })
                }
            }

            this.getExportUrl = (params) => {
                let paramsAll = angular.copy($stateParams);
                angular.extend(paramsAll, params);
                return "/crm/api/invoice-bgt-group-batch/export?" + $httpParamSerializer(paramsAll)
            }

            $scope.$on(InvoiceBgtGroupConst.eventUpdate, () => $state.reload())
        }
    })
